import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults, validateParameters } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\SiteController::assignReferrer
* @see app/Http/Controllers/SiteController.php:550
* @route '/apply_referral/{referralCode}'
*/
export const assignReferrer = (args: { referralCode: string | number } | [referralCode: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: assignReferrer.url(args, options),
    method: 'get',
})

assignReferrer.definition = {
    methods: ["get","head"],
    url: '/apply_referral/{referralCode}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteController::assignReferrer
* @see app/Http/Controllers/SiteController.php:550
* @route '/apply_referral/{referralCode}'
*/
assignReferrer.url = (args: { referralCode: string | number } | [referralCode: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { referralCode: args }
    }

    if (Array.isArray(args)) {
        args = {
            referralCode: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        referralCode: args.referralCode,
    }

    return assignReferrer.definition.url
            .replace('{referralCode}', parsedArgs.referralCode.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteController::assignReferrer
* @see app/Http/Controllers/SiteController.php:550
* @route '/apply_referral/{referralCode}'
*/
assignReferrer.get = (args: { referralCode: string | number } | [referralCode: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: assignReferrer.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::assignReferrer
* @see app/Http/Controllers/SiteController.php:550
* @route '/apply_referral/{referralCode}'
*/
assignReferrer.head = (args: { referralCode: string | number } | [referralCode: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: assignReferrer.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteController::assignReferrer
* @see app/Http/Controllers/SiteController.php:550
* @route '/apply_referral/{referralCode}'
*/
const assignReferrerForm = (args: { referralCode: string | number } | [referralCode: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: assignReferrer.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::assignReferrer
* @see app/Http/Controllers/SiteController.php:550
* @route '/apply_referral/{referralCode}'
*/
assignReferrerForm.get = (args: { referralCode: string | number } | [referralCode: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: assignReferrer.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::assignReferrer
* @see app/Http/Controllers/SiteController.php:550
* @route '/apply_referral/{referralCode}'
*/
assignReferrerForm.head = (args: { referralCode: string | number } | [referralCode: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: assignReferrer.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

assignReferrer.form = assignReferrerForm

/**
* @see \App\Http\Controllers\SiteController::check_payment
* @see app/Http/Controllers/SiteController.php:580
* @route '/check-payment/{trx}'
*/
export const check_payment = (args: { trx: string | number } | [trx: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: check_payment.url(args, options),
    method: 'get',
})

check_payment.definition = {
    methods: ["get","head"],
    url: '/check-payment/{trx}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteController::check_payment
* @see app/Http/Controllers/SiteController.php:580
* @route '/check-payment/{trx}'
*/
check_payment.url = (args: { trx: string | number } | [trx: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { trx: args }
    }

    if (Array.isArray(args)) {
        args = {
            trx: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        trx: args.trx,
    }

    return check_payment.definition.url
            .replace('{trx}', parsedArgs.trx.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteController::check_payment
* @see app/Http/Controllers/SiteController.php:580
* @route '/check-payment/{trx}'
*/
check_payment.get = (args: { trx: string | number } | [trx: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: check_payment.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::check_payment
* @see app/Http/Controllers/SiteController.php:580
* @route '/check-payment/{trx}'
*/
check_payment.head = (args: { trx: string | number } | [trx: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: check_payment.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteController::check_payment
* @see app/Http/Controllers/SiteController.php:580
* @route '/check-payment/{trx}'
*/
const check_paymentForm = (args: { trx: string | number } | [trx: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: check_payment.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::check_payment
* @see app/Http/Controllers/SiteController.php:580
* @route '/check-payment/{trx}'
*/
check_paymentForm.get = (args: { trx: string | number } | [trx: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: check_payment.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::check_payment
* @see app/Http/Controllers/SiteController.php:580
* @route '/check-payment/{trx}'
*/
check_paymentForm.head = (args: { trx: string | number } | [trx: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: check_payment.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

check_payment.form = check_paymentForm

/**
* @see \App\Http\Controllers\SiteController::allEvents
* @see app/Http/Controllers/SiteController.php:312
* @route '/events/{slug?}'
*/
export const allEvents = (args?: { slug?: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: allEvents.url(args, options),
    method: 'get',
})

allEvents.definition = {
    methods: ["get","head"],
    url: '/events/{slug?}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteController::allEvents
* @see app/Http/Controllers/SiteController.php:312
* @route '/events/{slug?}'
*/
allEvents.url = (args?: { slug?: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { slug: args }
    }

    if (Array.isArray(args)) {
        args = {
            slug: args[0],
        }
    }

    args = applyUrlDefaults(args)

    validateParameters(args, [
        "slug",
    ])

    const parsedArgs = {
        slug: args?.slug,
    }

    return allEvents.definition.url
            .replace('{slug?}', parsedArgs.slug?.toString() ?? '')
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteController::allEvents
* @see app/Http/Controllers/SiteController.php:312
* @route '/events/{slug?}'
*/
allEvents.get = (args?: { slug?: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: allEvents.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::allEvents
* @see app/Http/Controllers/SiteController.php:312
* @route '/events/{slug?}'
*/
allEvents.head = (args?: { slug?: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: allEvents.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteController::allEvents
* @see app/Http/Controllers/SiteController.php:312
* @route '/events/{slug?}'
*/
const allEventsForm = (args?: { slug?: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: allEvents.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::allEvents
* @see app/Http/Controllers/SiteController.php:312
* @route '/events/{slug?}'
*/
allEventsForm.get = (args?: { slug?: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: allEvents.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::allEvents
* @see app/Http/Controllers/SiteController.php:312
* @route '/events/{slug?}'
*/
allEventsForm.head = (args?: { slug?: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: allEvents.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

allEvents.form = allEventsForm

/**
* @see \App\Http\Controllers\SiteController::eventDetails
* @see app/Http/Controllers/SiteController.php:413
* @route '/event/{slug}'
*/
export const eventDetails = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: eventDetails.url(args, options),
    method: 'get',
})

eventDetails.definition = {
    methods: ["get","head"],
    url: '/event/{slug}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteController::eventDetails
* @see app/Http/Controllers/SiteController.php:413
* @route '/event/{slug}'
*/
eventDetails.url = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { slug: args }
    }

    if (Array.isArray(args)) {
        args = {
            slug: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        slug: args.slug,
    }

    return eventDetails.definition.url
            .replace('{slug}', parsedArgs.slug.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteController::eventDetails
* @see app/Http/Controllers/SiteController.php:413
* @route '/event/{slug}'
*/
eventDetails.get = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: eventDetails.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::eventDetails
* @see app/Http/Controllers/SiteController.php:413
* @route '/event/{slug}'
*/
eventDetails.head = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: eventDetails.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteController::eventDetails
* @see app/Http/Controllers/SiteController.php:413
* @route '/event/{slug}'
*/
const eventDetailsForm = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: eventDetails.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::eventDetails
* @see app/Http/Controllers/SiteController.php:413
* @route '/event/{slug}'
*/
eventDetailsForm.get = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: eventDetails.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::eventDetails
* @see app/Http/Controllers/SiteController.php:413
* @route '/event/{slug}'
*/
eventDetailsForm.head = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: eventDetails.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

eventDetails.form = eventDetailsForm

/**
* @see \App\Http\Controllers\SiteController::allOrganizers
* @see app/Http/Controllers/SiteController.php:461
* @route '/organizers'
*/
export const allOrganizers = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: allOrganizers.url(options),
    method: 'get',
})

allOrganizers.definition = {
    methods: ["get","head"],
    url: '/organizers',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteController::allOrganizers
* @see app/Http/Controllers/SiteController.php:461
* @route '/organizers'
*/
allOrganizers.url = (options?: RouteQueryOptions) => {
    return allOrganizers.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteController::allOrganizers
* @see app/Http/Controllers/SiteController.php:461
* @route '/organizers'
*/
allOrganizers.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: allOrganizers.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::allOrganizers
* @see app/Http/Controllers/SiteController.php:461
* @route '/organizers'
*/
allOrganizers.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: allOrganizers.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteController::allOrganizers
* @see app/Http/Controllers/SiteController.php:461
* @route '/organizers'
*/
const allOrganizersForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: allOrganizers.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::allOrganizers
* @see app/Http/Controllers/SiteController.php:461
* @route '/organizers'
*/
allOrganizersForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: allOrganizers.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::allOrganizers
* @see app/Http/Controllers/SiteController.php:461
* @route '/organizers'
*/
allOrganizersForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: allOrganizers.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

allOrganizers.form = allOrganizersForm

/**
* @see \App\Http\Controllers\SiteController::organizerDetails
* @see app/Http/Controllers/SiteController.php:451
* @route '/organizer/{slug}'
*/
export const organizerDetails = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: organizerDetails.url(args, options),
    method: 'get',
})

organizerDetails.definition = {
    methods: ["get","head"],
    url: '/organizer/{slug}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteController::organizerDetails
* @see app/Http/Controllers/SiteController.php:451
* @route '/organizer/{slug}'
*/
organizerDetails.url = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { slug: args }
    }

    if (Array.isArray(args)) {
        args = {
            slug: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        slug: args.slug,
    }

    return organizerDetails.definition.url
            .replace('{slug}', parsedArgs.slug.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteController::organizerDetails
* @see app/Http/Controllers/SiteController.php:451
* @route '/organizer/{slug}'
*/
organizerDetails.get = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: organizerDetails.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::organizerDetails
* @see app/Http/Controllers/SiteController.php:451
* @route '/organizer/{slug}'
*/
organizerDetails.head = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: organizerDetails.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteController::organizerDetails
* @see app/Http/Controllers/SiteController.php:451
* @route '/organizer/{slug}'
*/
const organizerDetailsForm = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: organizerDetails.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::organizerDetails
* @see app/Http/Controllers/SiteController.php:451
* @route '/organizer/{slug}'
*/
organizerDetailsForm.get = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: organizerDetails.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::organizerDetails
* @see app/Http/Controllers/SiteController.php:451
* @route '/organizer/{slug}'
*/
organizerDetailsForm.head = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: organizerDetails.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

organizerDetails.form = organizerDetailsForm

/**
* @see \App\Http\Controllers\SiteController::downloadTicket
* @see app/Http/Controllers/SiteController.php:469
* @route '/ticket-download/{ticketId}'
*/
export const downloadTicket = (args: { ticketId: string | number } | [ticketId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: downloadTicket.url(args, options),
    method: 'get',
})

downloadTicket.definition = {
    methods: ["get","head"],
    url: '/ticket-download/{ticketId}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteController::downloadTicket
* @see app/Http/Controllers/SiteController.php:469
* @route '/ticket-download/{ticketId}'
*/
downloadTicket.url = (args: { ticketId: string | number } | [ticketId: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { ticketId: args }
    }

    if (Array.isArray(args)) {
        args = {
            ticketId: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        ticketId: args.ticketId,
    }

    return downloadTicket.definition.url
            .replace('{ticketId}', parsedArgs.ticketId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteController::downloadTicket
* @see app/Http/Controllers/SiteController.php:469
* @route '/ticket-download/{ticketId}'
*/
downloadTicket.get = (args: { ticketId: string | number } | [ticketId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: downloadTicket.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::downloadTicket
* @see app/Http/Controllers/SiteController.php:469
* @route '/ticket-download/{ticketId}'
*/
downloadTicket.head = (args: { ticketId: string | number } | [ticketId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: downloadTicket.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteController::downloadTicket
* @see app/Http/Controllers/SiteController.php:469
* @route '/ticket-download/{ticketId}'
*/
const downloadTicketForm = (args: { ticketId: string | number } | [ticketId: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: downloadTicket.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::downloadTicket
* @see app/Http/Controllers/SiteController.php:469
* @route '/ticket-download/{ticketId}'
*/
downloadTicketForm.get = (args: { ticketId: string | number } | [ticketId: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: downloadTicket.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::downloadTicket
* @see app/Http/Controllers/SiteController.php:469
* @route '/ticket-download/{ticketId}'
*/
downloadTicketForm.head = (args: { ticketId: string | number } | [ticketId: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: downloadTicket.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

downloadTicket.form = downloadTicketForm

/**
* @see \App\Http\Controllers\SiteController::qrFromUrl
* @see app/Http/Controllers/SiteController.php:544
* @route '/qr-from-url'
*/
export const qrFromUrl = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: qrFromUrl.url(options),
    method: 'get',
})

qrFromUrl.definition = {
    methods: ["get","head"],
    url: '/qr-from-url',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteController::qrFromUrl
* @see app/Http/Controllers/SiteController.php:544
* @route '/qr-from-url'
*/
qrFromUrl.url = (options?: RouteQueryOptions) => {
    return qrFromUrl.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteController::qrFromUrl
* @see app/Http/Controllers/SiteController.php:544
* @route '/qr-from-url'
*/
qrFromUrl.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: qrFromUrl.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::qrFromUrl
* @see app/Http/Controllers/SiteController.php:544
* @route '/qr-from-url'
*/
qrFromUrl.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: qrFromUrl.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteController::qrFromUrl
* @see app/Http/Controllers/SiteController.php:544
* @route '/qr-from-url'
*/
const qrFromUrlForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: qrFromUrl.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::qrFromUrl
* @see app/Http/Controllers/SiteController.php:544
* @route '/qr-from-url'
*/
qrFromUrlForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: qrFromUrl.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::qrFromUrl
* @see app/Http/Controllers/SiteController.php:544
* @route '/qr-from-url'
*/
qrFromUrlForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: qrFromUrl.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

qrFromUrl.form = qrFromUrlForm

/**
* @see \App\Http\Controllers\SiteController::addSubscriber
* @see app/Http/Controllers/SiteController.php:258
* @route '/subscribe'
*/
export const addSubscriber = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: addSubscriber.url(options),
    method: 'post',
})

addSubscriber.definition = {
    methods: ["post"],
    url: '/subscribe',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SiteController::addSubscriber
* @see app/Http/Controllers/SiteController.php:258
* @route '/subscribe'
*/
addSubscriber.url = (options?: RouteQueryOptions) => {
    return addSubscriber.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteController::addSubscriber
* @see app/Http/Controllers/SiteController.php:258
* @route '/subscribe'
*/
addSubscriber.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: addSubscriber.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SiteController::addSubscriber
* @see app/Http/Controllers/SiteController.php:258
* @route '/subscribe'
*/
const addSubscriberForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: addSubscriber.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SiteController::addSubscriber
* @see app/Http/Controllers/SiteController.php:258
* @route '/subscribe'
*/
addSubscriberForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: addSubscriber.url(options),
    method: 'post',
})

addSubscriber.form = addSubscriberForm

/**
* @see \App\Http\Controllers\SiteController::contact
* @see app/Http/Controllers/SiteController.php:148
* @route '/contact'
*/
export const contact = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: contact.url(options),
    method: 'get',
})

contact.definition = {
    methods: ["get","head"],
    url: '/contact',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteController::contact
* @see app/Http/Controllers/SiteController.php:148
* @route '/contact'
*/
contact.url = (options?: RouteQueryOptions) => {
    return contact.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteController::contact
* @see app/Http/Controllers/SiteController.php:148
* @route '/contact'
*/
contact.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: contact.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::contact
* @see app/Http/Controllers/SiteController.php:148
* @route '/contact'
*/
contact.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: contact.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteController::contact
* @see app/Http/Controllers/SiteController.php:148
* @route '/contact'
*/
const contactForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contact.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::contact
* @see app/Http/Controllers/SiteController.php:148
* @route '/contact'
*/
contactForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contact.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::contact
* @see app/Http/Controllers/SiteController.php:148
* @route '/contact'
*/
contactForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contact.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

contact.form = contactForm

/**
* @see \App\Http\Controllers\SiteController::contactSubmit
* @see app/Http/Controllers/SiteController.php:159
* @route '/contact'
*/
export const contactSubmit = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: contactSubmit.url(options),
    method: 'post',
})

contactSubmit.definition = {
    methods: ["post"],
    url: '/contact',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SiteController::contactSubmit
* @see app/Http/Controllers/SiteController.php:159
* @route '/contact'
*/
contactSubmit.url = (options?: RouteQueryOptions) => {
    return contactSubmit.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteController::contactSubmit
* @see app/Http/Controllers/SiteController.php:159
* @route '/contact'
*/
contactSubmit.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: contactSubmit.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SiteController::contactSubmit
* @see app/Http/Controllers/SiteController.php:159
* @route '/contact'
*/
const contactSubmitForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: contactSubmit.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SiteController::contactSubmit
* @see app/Http/Controllers/SiteController.php:159
* @route '/contact'
*/
contactSubmitForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: contactSubmit.url(options),
    method: 'post',
})

contactSubmit.form = contactSubmitForm

/**
* @see \App\Http\Controllers\SiteController::changeLanguage
* @see app/Http/Controllers/SiteController.php:215
* @route '/change/{lang?}'
*/
export const changeLanguage = (args?: { lang?: string | number } | [lang: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: changeLanguage.url(args, options),
    method: 'get',
})

changeLanguage.definition = {
    methods: ["get","head"],
    url: '/change/{lang?}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteController::changeLanguage
* @see app/Http/Controllers/SiteController.php:215
* @route '/change/{lang?}'
*/
changeLanguage.url = (args?: { lang?: string | number } | [lang: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { lang: args }
    }

    if (Array.isArray(args)) {
        args = {
            lang: args[0],
        }
    }

    args = applyUrlDefaults(args)

    validateParameters(args, [
        "lang",
    ])

    const parsedArgs = {
        lang: args?.lang,
    }

    return changeLanguage.definition.url
            .replace('{lang?}', parsedArgs.lang?.toString() ?? '')
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteController::changeLanguage
* @see app/Http/Controllers/SiteController.php:215
* @route '/change/{lang?}'
*/
changeLanguage.get = (args?: { lang?: string | number } | [lang: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: changeLanguage.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::changeLanguage
* @see app/Http/Controllers/SiteController.php:215
* @route '/change/{lang?}'
*/
changeLanguage.head = (args?: { lang?: string | number } | [lang: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: changeLanguage.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteController::changeLanguage
* @see app/Http/Controllers/SiteController.php:215
* @route '/change/{lang?}'
*/
const changeLanguageForm = (args?: { lang?: string | number } | [lang: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: changeLanguage.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::changeLanguage
* @see app/Http/Controllers/SiteController.php:215
* @route '/change/{lang?}'
*/
changeLanguageForm.get = (args?: { lang?: string | number } | [lang: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: changeLanguage.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::changeLanguage
* @see app/Http/Controllers/SiteController.php:215
* @route '/change/{lang?}'
*/
changeLanguageForm.head = (args?: { lang?: string | number } | [lang: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: changeLanguage.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

changeLanguage.form = changeLanguageForm

/**
* @see \App\Http\Controllers\SiteController::cookiePolicy
* @see app/Http/Controllers/SiteController.php:249
* @route '/cookie-policy'
*/
export const cookiePolicy = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cookiePolicy.url(options),
    method: 'get',
})

cookiePolicy.definition = {
    methods: ["get","head"],
    url: '/cookie-policy',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteController::cookiePolicy
* @see app/Http/Controllers/SiteController.php:249
* @route '/cookie-policy'
*/
cookiePolicy.url = (options?: RouteQueryOptions) => {
    return cookiePolicy.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteController::cookiePolicy
* @see app/Http/Controllers/SiteController.php:249
* @route '/cookie-policy'
*/
cookiePolicy.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cookiePolicy.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::cookiePolicy
* @see app/Http/Controllers/SiteController.php:249
* @route '/cookie-policy'
*/
cookiePolicy.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: cookiePolicy.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteController::cookiePolicy
* @see app/Http/Controllers/SiteController.php:249
* @route '/cookie-policy'
*/
const cookiePolicyForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cookiePolicy.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::cookiePolicy
* @see app/Http/Controllers/SiteController.php:249
* @route '/cookie-policy'
*/
cookiePolicyForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cookiePolicy.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::cookiePolicy
* @see app/Http/Controllers/SiteController.php:249
* @route '/cookie-policy'
*/
cookiePolicyForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cookiePolicy.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

cookiePolicy.form = cookiePolicyForm

/**
* @see \App\Http\Controllers\SiteController::cookieAccept
* @see app/Http/Controllers/SiteController.php:244
* @route '/cookie/accept'
*/
export const cookieAccept = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cookieAccept.url(options),
    method: 'get',
})

cookieAccept.definition = {
    methods: ["get","head"],
    url: '/cookie/accept',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteController::cookieAccept
* @see app/Http/Controllers/SiteController.php:244
* @route '/cookie/accept'
*/
cookieAccept.url = (options?: RouteQueryOptions) => {
    return cookieAccept.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteController::cookieAccept
* @see app/Http/Controllers/SiteController.php:244
* @route '/cookie/accept'
*/
cookieAccept.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cookieAccept.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::cookieAccept
* @see app/Http/Controllers/SiteController.php:244
* @route '/cookie/accept'
*/
cookieAccept.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: cookieAccept.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteController::cookieAccept
* @see app/Http/Controllers/SiteController.php:244
* @route '/cookie/accept'
*/
const cookieAcceptForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cookieAccept.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::cookieAccept
* @see app/Http/Controllers/SiteController.php:244
* @route '/cookie/accept'
*/
cookieAcceptForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cookieAccept.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::cookieAccept
* @see app/Http/Controllers/SiteController.php:244
* @route '/cookie/accept'
*/
cookieAcceptForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cookieAccept.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

cookieAccept.form = cookieAcceptForm

/**
* @see \App\Http\Controllers\SiteController::policyPages
* @see app/Http/Controllers/SiteController.php:206
* @route '/policy/{slug}'
*/
export const policyPages = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: policyPages.url(args, options),
    method: 'get',
})

policyPages.definition = {
    methods: ["get","head"],
    url: '/policy/{slug}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteController::policyPages
* @see app/Http/Controllers/SiteController.php:206
* @route '/policy/{slug}'
*/
policyPages.url = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { slug: args }
    }

    if (Array.isArray(args)) {
        args = {
            slug: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        slug: args.slug,
    }

    return policyPages.definition.url
            .replace('{slug}', parsedArgs.slug.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteController::policyPages
* @see app/Http/Controllers/SiteController.php:206
* @route '/policy/{slug}'
*/
policyPages.get = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: policyPages.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::policyPages
* @see app/Http/Controllers/SiteController.php:206
* @route '/policy/{slug}'
*/
policyPages.head = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: policyPages.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteController::policyPages
* @see app/Http/Controllers/SiteController.php:206
* @route '/policy/{slug}'
*/
const policyPagesForm = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: policyPages.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::policyPages
* @see app/Http/Controllers/SiteController.php:206
* @route '/policy/{slug}'
*/
policyPagesForm.get = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: policyPages.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::policyPages
* @see app/Http/Controllers/SiteController.php:206
* @route '/policy/{slug}'
*/
policyPagesForm.head = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: policyPages.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

policyPages.form = policyPagesForm

/**
* @see \App\Http\Controllers\SiteController::placeholderImage
* @see app/Http/Controllers/SiteController.php:273
* @route '/placeholder-image/{size}'
*/
export const placeholderImage = (args: { size: string | number } | [size: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: placeholderImage.url(args, options),
    method: 'get',
})

placeholderImage.definition = {
    methods: ["get","head"],
    url: '/placeholder-image/{size}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteController::placeholderImage
* @see app/Http/Controllers/SiteController.php:273
* @route '/placeholder-image/{size}'
*/
placeholderImage.url = (args: { size: string | number } | [size: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { size: args }
    }

    if (Array.isArray(args)) {
        args = {
            size: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        size: args.size,
    }

    return placeholderImage.definition.url
            .replace('{size}', parsedArgs.size.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteController::placeholderImage
* @see app/Http/Controllers/SiteController.php:273
* @route '/placeholder-image/{size}'
*/
placeholderImage.get = (args: { size: string | number } | [size: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: placeholderImage.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::placeholderImage
* @see app/Http/Controllers/SiteController.php:273
* @route '/placeholder-image/{size}'
*/
placeholderImage.head = (args: { size: string | number } | [size: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: placeholderImage.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteController::placeholderImage
* @see app/Http/Controllers/SiteController.php:273
* @route '/placeholder-image/{size}'
*/
const placeholderImageForm = (args: { size: string | number } | [size: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: placeholderImage.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::placeholderImage
* @see app/Http/Controllers/SiteController.php:273
* @route '/placeholder-image/{size}'
*/
placeholderImageForm.get = (args: { size: string | number } | [size: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: placeholderImage.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::placeholderImage
* @see app/Http/Controllers/SiteController.php:273
* @route '/placeholder-image/{size}'
*/
placeholderImageForm.head = (args: { size: string | number } | [size: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: placeholderImage.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

placeholderImage.form = placeholderImageForm

/**
* @see \App\Http\Controllers\SiteController::searchv2
* @see app/Http/Controllers/SiteController.php:64
* @route '/search'
*/
export const searchv2 = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: searchv2.url(options),
    method: 'get',
})

searchv2.definition = {
    methods: ["get","head"],
    url: '/search',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteController::searchv2
* @see app/Http/Controllers/SiteController.php:64
* @route '/search'
*/
searchv2.url = (options?: RouteQueryOptions) => {
    return searchv2.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteController::searchv2
* @see app/Http/Controllers/SiteController.php:64
* @route '/search'
*/
searchv2.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: searchv2.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::searchv2
* @see app/Http/Controllers/SiteController.php:64
* @route '/search'
*/
searchv2.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: searchv2.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteController::searchv2
* @see app/Http/Controllers/SiteController.php:64
* @route '/search'
*/
const searchv2Form = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: searchv2.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::searchv2
* @see app/Http/Controllers/SiteController.php:64
* @route '/search'
*/
searchv2Form.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: searchv2.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::searchv2
* @see app/Http/Controllers/SiteController.php:64
* @route '/search'
*/
searchv2Form.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: searchv2.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

searchv2.form = searchv2Form

/**
* @see \App\Http\Controllers\SiteController::zalo_verify
* @see app/Http/Controllers/SiteController.php:575
* @route '/zalo_verifierSEIvAvlaR2nybxvxd-CUVsZNYa64eLiRE3av'
*/
export const zalo_verify = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: zalo_verify.url(options),
    method: 'get',
})

zalo_verify.definition = {
    methods: ["get","head"],
    url: '/zalo_verifierSEIvAvlaR2nybxvxd-CUVsZNYa64eLiRE3av',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteController::zalo_verify
* @see app/Http/Controllers/SiteController.php:575
* @route '/zalo_verifierSEIvAvlaR2nybxvxd-CUVsZNYa64eLiRE3av'
*/
zalo_verify.url = (options?: RouteQueryOptions) => {
    return zalo_verify.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteController::zalo_verify
* @see app/Http/Controllers/SiteController.php:575
* @route '/zalo_verifierSEIvAvlaR2nybxvxd-CUVsZNYa64eLiRE3av'
*/
zalo_verify.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: zalo_verify.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::zalo_verify
* @see app/Http/Controllers/SiteController.php:575
* @route '/zalo_verifierSEIvAvlaR2nybxvxd-CUVsZNYa64eLiRE3av'
*/
zalo_verify.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: zalo_verify.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteController::zalo_verify
* @see app/Http/Controllers/SiteController.php:575
* @route '/zalo_verifierSEIvAvlaR2nybxvxd-CUVsZNYa64eLiRE3av'
*/
const zalo_verifyForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: zalo_verify.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::zalo_verify
* @see app/Http/Controllers/SiteController.php:575
* @route '/zalo_verifierSEIvAvlaR2nybxvxd-CUVsZNYa64eLiRE3av'
*/
zalo_verifyForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: zalo_verify.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteController::zalo_verify
* @see app/Http/Controllers/SiteController.php:575
* @route '/zalo_verifierSEIvAvlaR2nybxvxd-CUVsZNYa64eLiRE3av'
*/
zalo_verifyForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: zalo_verify.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

zalo_verify.form = zalo_verifyForm

const SiteController = { assignReferrer, check_payment, allEvents, eventDetails, allOrganizers, organizerDetails, downloadTicket, qrFromUrl, addSubscriber, contact, contactSubmit, changeLanguage, cookiePolicy, cookieAccept, policyPages, placeholderImage, searchv2, zalo_verify }

export default SiteController